/**
* @name: xm-menu-li
* @author: weiyong
* @date: 2023-05-12 00:12
* @description：xm-menu-li
* @update: 2023-05-12 00:12
*/
<template>
  <div class="el-custom-sidebar-icon-container flex-div"
       :class="openFlag?'':'el-custom-sidebar--collapse'">
<!--    <div v-if="activeItem" class="active-tab"></div>-->
    <div class="item-icon">
      <span :class="menuItem.icon||menuItem.source"/>
    </div>
    <span class="open-item-label"  v-if="openFlag" :title="menuItem.label||menuItem.name">{{ menuItem.label||menuItem.name }}</span>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xm-menu-li",
});
</script>

<script lang="ts" setup>

interface IProps{
  activeItem:boolean,
  menuItem:any,
  openFlag:boolean,
}

const props=withDefaults(defineProps<IProps>(),{
  openFlag:false,
  activeItem:false,
  menuItem:{},
})
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-xm-menu-li';

.@{prefix-cls} {

}
</style>
